import MediaSelector from "../editor/fields/MediaSelector";
import { TailwindWrapper } from "@utils/TailwindWrapper";

export type ImagePostsProps = {
  src?: string;
  alt?: string;
};

export const ImagePosts = (props: ImagePostsProps) => {
  return (
    <TailwindWrapper>
      <div className="mx-auto mb-12 w-full max-w-[720px] px-4 sm:px-6">
        <div className="flex h-[185px] w-full flex-col items-start self-stretch overflow-hidden rounded-xl border bg-gray-100 aspect-8/5 md:aspect-video md:h-[405px]">
          <img
            alt={props.alt || "Hero image"}
            src={props.src || "https://placehold.co/1200x1200"}
            className="h-full w-full object-cover"
          />
        </div>
      </div>
    </TailwindWrapper>
  );
};

ImagePosts.fields = {
  src: {
    type: "custom",
    label: "Hero image",
    render: ({
      name,
      onChange,
      value,
    }: {
      name: string;
      onChange: (value: string) => void;
      value: string;
    }) => (
      <MediaSelector
        name={name}
        label="Hero image"
        type="img"
        onChange={onChange}
        value={value}
      />
    ),
  },
  alt: {
    type: "text",
    label: "Alt text",
  },
};
